import React from "react"
import { Link } from "react-router-dom"
import { useNavigationBlock } from "../../contexts/NavigationBlock.context"

const BLink = ({ children, href, to, ...props }) => {
  const { isBlocked, setAttemptedNavigation } = useNavigationBlock()

  const handleClick = (e) => {
    if (isBlocked) {
      e.preventDefault()
      setAttemptedNavigation([true, href || to])
    } else {
      props.onClick?.(e)
    }
  }

  return (
    <Link to={to || href} {...props} onClick={handleClick}>
      {children}
    </Link>
  )
}

export default BLink
